import { Duration, Instant } from "@js-joda/core";
import { computed, ref } from "vue";

const versionMismatchedAt = ref<Instant | null>(null);
const versionMismatchThresholdMet = ref<boolean>(false);

const versionMismatchThreshold = Duration.ofHours(1);

export default {
  requiresForcedRefresh: computed<boolean>(
    () => versionMismatchThresholdMet.value
  ),
  compareVersions: (
    serverApiVersion: string,
    clientApiVersion: string
  ): void => {
    if (clientApiVersion !== serverApiVersion) {
      // eslint-disable-next-line no-console
      console.warn(
        `Client Api Version (${clientApiVersion}) <-> Server (${serverApiVersion}) Version Mismatch.`
      );
      if (versionMismatchedAt.value === null) {
        versionMismatchedAt.value = Instant.now();
      } else {
        if (
          versionMismatchedAt.value
            .plus(versionMismatchThreshold)
            .isBefore(Instant.now())
        ) {
          versionMismatchThresholdMet.value = true;
        }
      }
    } else if (versionMismatchedAt.value !== null) {
      versionMismatchedAt.value = null;
    }
  },
  requiresRefresh: () => !!versionMismatchedAt.value,
};
